import React, { useState } from 'react';
import he from 'he';
import './styles.scss';

interface TeaserboxProps {
    size: 'large' | 'small' | 'foldable';
    headline: string;
    subline?: string;
    text: string;
    asset: string;
    onClick?: () => void;
    id?: string;
}

export default function Teaserbox({ size, headline, subline, text, asset, onClick, id }: TeaserboxProps): JSX.Element {
    const [expand, setExpand] = useState(false);
    const decodedText = he.decode(text);

    return (
        <article id={id} className={`teaserbox ${size}`} onClick={onClick}>
            {asset?.includes('.webm') ? (
                <video src={asset} autoPlay={true} playsInline={true} muted={true} loop={true}></video>
            ) : (
                <img src={asset} alt=''></img>
            )}

            <h3>{headline}</h3>
            {subline && <h4 style={{ whiteSpace: 'pre-line' }}>{subline}</h4>}
            <p className={`body ${size} ${expand ? 'expand' : ''}`} style={{ whiteSpace: 'pre-line' }}>
                {decodedText}
                {size !== 'foldable' && (
                    size === 'large' ?
                    <svg className='icon-24'>
                        <use xlinkHref='#as-arrow-right'></use>
                    </svg> : <svg className='icon-20'>
                            <use xlinkHref='#as-arrow-right-20'></use>
                        </svg>
                )}
            </p>

            {size === 'foldable' && (
                <>
                    <div className={`shadow ${expand ? 'hide' : ''}`} />
                    <button onClick={() => setExpand(!expand)}>
                        <svg className={`icon-24 ${expand ? 'rotate' : ''}`}>
                            <use xlinkHref={'#chevron-narrow-right'} />
                        </svg>
                    </button>
                </>
            )}
        </article>
    );
}
